import styled from "styled-components";

export const CardInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacing?.lg || "24px"};
  width: 100%;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.xs || "4px"};
  min-width: 0;
  flex: 1;
`;

export const ButtonWrap = styled.div`
  flex-shrink: 0;
`;
